import React from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";

const DashboardStandard = () => {
  const totalFixedCost = useSelector((state) => state.totalFixedCost);
  const totalYearGrossMargin = useSelector(
    (state) => state.totalYearGrossMargin
  );
  const totalAnnualSales = useSelector((state) => state.totalAnnualSales);
  const netProfitPerMonth = useSelector(
    (state) => state.salaryCalculation.netProfitPerMonth
  );

  const totalMeasuredCostsYear1 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year1
  );
  const totalMeasuredCostsYear2 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year2
  );
  const totalMeasuredCostsYear3 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year3
  );

  const activeYear = useSelector((state) => state.year);
  function getTotalMeasuredCostsYear() {
    let resultMeasured = 0;
    if (activeYear.year === "year1") {
      resultMeasured = Math.round(
        totalMeasuredCostsYear1 > 0 ? totalMeasuredCostsYear1 : 0
      );
    }
    if (activeYear.year === "year2") {
      resultMeasured = Math.round(
        totalMeasuredCostsYear2 > 0 ? totalMeasuredCostsYear2 : 0
      );
    }
    if (activeYear.year === "year3") {
      resultMeasured = Math.round(
        totalMeasuredCostsYear3 > 0 ? totalMeasuredCostsYear3 : 0
      );
    }
    return resultMeasured;
  }

  return (
    <Col xs={10} className="offset-5">
      <Row>
        <Col
          xs={28}
          className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
        >
          Månadslön (netto)
        </Col>
        <Col xs={12} style={{ padding: "0px" }}>
          <output className="form-control text-center dashboard-output">
            {Math.round(netProfitPerMonth >= 0 ? netProfitPerMonth : 0)}
          </output>
        </Col>
      </Row>
      <Row>
        <Col
          xs={28}
          className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
        >
          Årsförsäljning
        </Col>
        <Col xs={12} style={{ padding: "0px" }}>
          <output className="form-control text-center dashboard-output">
            {Math.round(totalAnnualSales >= 0 ? totalAnnualSales : 0)}
          </output>
        </Col>
      </Row>
      <Row>
        <Col
          xs={28}
          className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
        >
          Årstäckningsbidrag
        </Col>
        <Col xs={12} style={{ padding: "0px" }}>
          <output className="form-control text-center dashboard-output">
            {Math.round(totalYearGrossMargin >= 0 ? totalYearGrossMargin : 0)}
          </output>
        </Col>
      </Row>

      <Row>
        <Col
          xs={28}
          className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
        >
          Fasta kostnader
        </Col>
        <Col xs={12} style={{ padding: "0px" }}>
          <output className="form-control text-center dashboard-output">
            {Math.round(totalFixedCost > 0 ? totalFixedCost : 0)}
          </output>
        </Col>
      </Row>
      <Row>
        <Col
          xs={28}
          className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
        >
          Åtgärdskostnader
        </Col>
        <Col xs={12} style={{ padding: "0px" }}>
          <output className="form-control text-center dashboard-output">
            {getTotalMeasuredCostsYear()}
          </output>
        </Col>
      </Row>
    </Col>
  );
};
export default DashboardStandard;
